import { use } from "react";
import { AnalyticsContext } from "./AnalyticsContext";

export function useAnalytics() {
  return use(AnalyticsContext);
}
